<div id="course_modal" class="modal  custom-modal fade" role="dialog">
    <div class="modal-dialog   modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="zero_optn_grp_form_title"> {{header}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form [formGroup]="courseForm" (ngSubmit)="onSubmitCourse()" class="horizontal-form" method="post" enctype="multipart/form-data">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Course Name {{course_name}}<span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="course_name">
                                    <option value="">Select Course</option>    
                                    <option value="{{item.course_id}}" *ngFor="let item of coursesData;">{{item.course_desc}}</option>    
                                </select>
                                <div *ngIf="submitted && crseErrorMsg.course_name.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.course_name.errors.required">Course Name !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Institute<span class="text-danger">*</span></label>
                                <input class="form-control" type="text" placeholder="Institute" formControlName="inst_name">
                                <div *ngIf="submitted && crseErrorMsg.inst_name.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.inst_name.errors.required">Institute !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Course Start Date<span class="text-danger">*</span></label>
                                <input type="date" class="form-control" formControlName="start_date">
                                <div *ngIf="submitted && crseErrorMsg.start_date.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.start_date.errors.required">Course Start Date !</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Validity Date<span class="text-danger">*</span></label>
                                <input type="date" class="form-control" formControlName="valid_date">
                                <div *ngIf="submitted && crseErrorMsg.valid_date.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.valid_date.errors.required">Validity Date !</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Attachment<span class="text-danger">*</span></label>
                                <input type="file" class="form-control" (change)="onFileChange($event)" formControlName="attachment">
                                <div *ngIf="submitted && crseErrorMsg.attachment.errors" class="form-error">
                                    <div *ngIf="crseErrorMsg.attachment.errors.required">Attachment !</div>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="modal-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary btn-sm "><span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span><i class="fa fa-save"></i> SAVE</button>
                    <button type="button" class="btn btn-danger btn-sm" (click)="onReset()" data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>